import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import moment from 'moment';
import { environment } from '../../../../environments/environment';
import * as fromShared from '../../../shared';
import {
    FilterService,
    SelectItem,
    Table
} from '../../../shared/efaact-primeng.module';
import * as fromStore from '../store';

@Component({
    selector: 'ef-invoice-charge-number',
    templateUrl: './invoice-charge-number.component.html',
    styleUrls: ['./invoice-charge-number.component.scss'],
    standalone: false
})
export class InvoiceChargeNumberComponent
    extends fromShared.EditGrid<fromStore.ChargeNumber.InvoiceChargeNumber>
    implements OnInit
{
    loading = true;
    moment: any;
    dropdownItemHeight = environment.dropdownItemHeight;
    virtualItems: fromStore.ChargeNumber.InvoiceChargeNumber[];
    public get contracts(): SelectItem[] {
        if (this.items && this.items.length > 0) {
            return fromShared
                .uniqBy(
                    this.items as fromStore.ChargeNumber.InvoiceChargeNumber[],
                    x => x.ChargeNumber
                )
                .map(x => ({ label: x.ChargeNumber, value: x.ChargeNumber }));
        } else {
            return [];
        }
    }
    rowGroupMetadata: any = {};
    @ViewChild('dtChargeNumber') dataTable: Table;
    startDateFilter: any;
    endDateFilter: any;
    lastModifiedFilter: any;
    constructor(
        private log: fromShared.Services.Logging.LoggingService,
        private filterService: FilterService,
        private cdRef: ChangeDetectorRef
    ) {
        super();
        this.moment = moment;
    }
    ngOnInit() {
        this.addDateRangeFilter();
        // setTimeout(() => {
        //     this.dataTable.sort({
        //         data: this.items,
        //         field: 'ContractDesc',
        //         mode: 'single',
        //         order: 1
        //     });
        // }, 0);
    }
    addDateRangeFilter() {
        this.filterService.register(
            'startChargeNumberDateFilter',
            (value, filter): boolean => {
                this.log.verbose({
                    type: 'InvoiceChargeNumberComponent:startDateFilter',
                    value,
                    filter
                });
                if (value === undefined || value === null) {
                    return false;
                }
                return moment(value).isBetween(
                    moment(this.startDateFilter[0]),
                    moment(this.startDateFilter[1])
                );
                // get the from/start value
            }
        );
        this.filterService.register(
            'endChargeNumberDateFilter',
            (value, filter): boolean => {
                this.log.verbose({
                    type: 'InvoiceChargeNumberComponent:endDateFilter',
                    value,
                    filter
                });
                if (value === undefined || value === null) {
                    return false;
                }
                return moment(value).isBetween(
                    moment(this.endDateFilter[0]),
                    moment(this.endDateFilter[1])
                );
                // get the from/start value
            }
        );
    }
}
